import React, { createContext, useContext, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

const NavigationBlockerContext = createContext();

export const useBlockNavigation = () => useContext(NavigationBlockerContext);

export const NavigationBlockerProvider = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [blocker, setBlocker] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [nextPath, setNextPath] = useState(null);

  const allowNavigationRef = useRef(false);

//   const showDialog = (targetPath) => {
//     if (blocker) {
//       setNextPath(targetPath);
//       setDialogOpen(true);
//     } else {
//       navigate(targetPath);
//     }
//   };

  const showDialog = ({ to, state }) => {
    if (blocker) {
      setNextPath({ to, state });
      setDialogOpen(true);
    } else {
      navigate(to, { state });
    }
  };

  const confirmNavigation = () => {
    allowNavigationRef.current = true;
    setDialogOpen(false);
    setBlocker(false);
    const { to, state } = nextPath;
    navigate(to, { state });
  };

  const cancelNavigation = () => {
    setDialogOpen(false);
    setNextPath(null);
    allowNavigationRef.current = false;
  };

  return (
    <NavigationBlockerContext.Provider
      value={{
        setBlocker,
        getBlocker: () => blocker,
        showDialog
      }}
    >
      {children}
      <Dialog open={dialogOpen} onClose={cancelNavigation}>
        <DialogTitle>Unsaved Changes</DialogTitle>
        <DialogContent>
          You have unsaved changes. Are you sure you want to leave this page?
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelNavigation}>Stay</Button>
          <Button onClick={confirmNavigation} color="error">Leave</Button>
        </DialogActions>
      </Dialog>
    </NavigationBlockerContext.Provider>
  );
};
